import {
  faClipboard,
  faUserNurse,
  faSuitcaseMedical,
  faTreeCity,
  faMap,
  faCircleInfo,
  faToolbox,
  faUsers,
  faUser,
  faLightbulb,
  faCommentDots,
  faTruckMedical,
} from '@fortawesome/free-solid-svg-icons'

export const RegisterDrawerItems = [
  {
    title: 'Questionários',
    href: '/app/questionnaire/list',
    icon: faClipboard,
  },
  {
    title: 'Unidades de saúde',
    href: '/app/health-units',
    icon: faSuitcaseMedical,
  },
  {
    title: 'Equipes de saúde',
    href: '/app/health-teams',
    icon: faUserNurse,
  },
  // {
  //   title: 'Unidades escolares',
  //   href: '/app/educational-unit/geo/update',
  //   icon: faSchool,
  // },
  {
    title: 'Agentes de saúde',
    href: '/app/health-professionals',
    icon: faUserNurse,
  },
  {
    title: 'Atendimentos',
    href: '/app/attendances',
    icon: faTruckMedical,
  },
  {
    title: 'Bairros',
    href: '/app/neighborhoods',
    icon: faTreeCity,
  },
]

export const GeneralDrawerItems = [
  {
    title: 'Sentinela',
    href: '/',
    icon: faMap,
  },
  {
    title: 'Insights',
    href: '/app/insights',
    icon: faLightbulb,
  },
  {
    title: 'Prix AI',
    href: '/app/ai',
    icon: faCommentDots,
  },
  {
    title: 'Informações do Sistema',
    href: '/app/system-information',
    icon: faCircleInfo,
  },
  {
    title: 'Notas de atualização',
    href: '/app/patch-notes',
    icon: faToolbox,
  },
]

export const ProfileDrawerItems = [
  {
    title: 'Meu perfil',
    href: '/app/profile',
    icon: faUser,
  },
  {
    title: 'Usuários',
    href: '/app/users',
    icon: faUsers,
  },
]
